module.exports = __webpack_public_path__ + "static/img/others_age.e7970c97.png";